import { Locale } from '@/lang/types';
import { locales } from '@/lang/locales';

export default function removeLangQualityValues(lang: string = locales.EN): Locale {
  const upperCaseLang = lang?.toUpperCase();

  if (upperCaseLang === undefined || upperCaseLang === null) return null;
  else if (upperCaseLang?.includes('AR')) return 'AR';
  else if (upperCaseLang?.includes('EN')) return 'EN';
  else return 'EN';
}
